export default __webpack_public_path__ + "static/media/Upworthy.6ac52fbf.svg";